import { getRootContainerProps } from "@client/content/lib/helper";
import { ModuleButton, ModuleSecondaryButton } from "@client/content/modules/Button";
import { type RootContainerProps } from "@client/content/types";
import Modal from "@client/controls/Modal/container";
import { type ConfirmModalActionProps, type ConfirmModalMapProps } from "@client/controls/Modal/Modals/Confirm/component";
import { FormButtons } from "@common/controls/Form/component";
import { useI18n } from "@common/hooks/i18n";
import classNames from "classnames";
import * as React from "react";

export const ModuleConfirmModal = (props: ConfirmModalActionProps & ConfirmModalMapProps & RootContainerProps) => {
  const i18n = useI18n();

  const content = props.children ?? props.message;
  return (
    <Modal
      {...props}
      className={classNames(props.className, "confirmation", { "admin _theme_": props.isAdmin })}
      isCentered
      isTopMost
      hasBackdrop
    >
      <Modal.Header title={props.title || "Confirmation"} />
      <Modal.Body>
        {typeof content === "string" ? <div dangerouslySetInnerHTML={{ __html: content }} /> : content}
      </Modal.Body>
      <Modal.Footer>
        <FormButtons>
          <ModuleSecondaryButton {...getRootContainerProps(props)} onClick={props.onClose}>
            {i18n.cancel}
          </ModuleSecondaryButton>
          <ModuleButton {...getRootContainerProps(props)} onClick={props.onConfirm}>
            {i18n.confirm}
          </ModuleButton>
        </FormButtons>
      </Modal.Footer>
    </Modal>
  );
};
